import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Polls a breakout room every 2s (paused while the tab is hidden); stops once the room is closed or gone.
export const useRoomSync = (base, rid, auth) => {
  const [room, setRoom] = useState(null);
  const [events, setEvents] = useState([]);
  const [err, setErr] = useState(null);
  const last = useRef(0);
  const merge = useCallback((evs) => setEvents((cur) => {
    const seen = new Set(cur.map((e) => e.seq));
    const add = evs.filter((e) => e && !seen.has(e.seq));
    return add.length ? [...cur, ...add].sort((a, b) => a.seq - b.seq) : cur;
  }), []);
  useEffect(() => {
    if (!rid) return undefined;
    let stop = false;
    let timer;
    last.current = 0;
    setEvents([]);
    setRoom(null);
    const tick = async () => {
      if (stop) return;
      if (!document.hidden) {
        try {
          const { data } = await api.get(`${base}/${rid}/sync?after=${last.current}`, auth);
          if (stop) return;
          setRoom(data.room);
          merge(data.events);
          last.current = Math.max(last.current, data.last);
          setErr(null);
          if (data.room.status !== "open") return;
        } catch (e) {
          setErr(e.response?.status || "net");
          if ([401, 403, 404].includes(e.response?.status)) return;
        }
      }
      timer = setTimeout(tick, 2000);
    };
    tick();
    return () => { stop = true; clearTimeout(timer); };
  }, [base, rid, auth, merge]);
  return { room, events, merge, err };
};
